export const DOUBLE_OPT_IN_BANNER_TEST_ID = "double-opt-in-banner";
